import { Base } from "../../framework/base";
import { Dictionary } from "./dictionary";
var IdTitleNode = /** @class */ (function () {
    function IdTitleNode(obj) {
        this.id = obj && obj.id || "";
        this.title = obj && obj.title || "";
        this.comment = obj && obj.comment || "";
        this.active = obj && obj.active || false;
        this.children = Base.getTypedArray(obj ? obj.children : null, IdTitleNode);
        this.attributes = new Dictionary();
        if (obj && obj.attributes) {
            for (var key in obj.attributes.values) {
                this.attributes.add(key, obj.attributes.values[key]);
            }
        }
    }
    IdTitleNode.createIdTitleNode = function (id, title, children, active, attributes, comment) {
        if (active === void 0) { active = true; }
        if (attributes === void 0) { attributes = null; }
        if (comment === void 0) { comment = ""; }
        var result = new IdTitleNode();
        result.id = id;
        result.title = title;
        result.comment = comment;
        result.active = active;
        result.children = children;
        if (attributes) {
            if (attributes) {
                for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
                    var item = attributes_1[_i];
                    result.attributes.add(item.key, item.value);
                }
            }
        }
        return result;
    };
    IdTitleNode.prototype.getTitle = function () {
        return this.title;
    };
    IdTitleNode.prototype.getAttributeValue = function (key) {
        return this.attributes.get(key);
    };
    IdTitleNode.prototype.hasChildren = function () {
        return this.children.length > 0;
    };
    IdTitleNode.prototype.getById = function (id) {
        if (id === this.id)
            return this;
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            var result = child.getById(id);
            if (!result)
                continue;
            return result;
        }
        return null;
    };
    IdTitleNode.getById = function (items, id) {
        if (!items || items.length < 1)
            return null;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var result = item.getById(id);
            if (!result)
                continue;
            return result;
        }
        return null;
    };
    IdTitleNode.prototype.getByIds = function (ids) {
        var result = [];
        if (ids.indexOf(this.id) > -1) {
            result.push(this);
        }
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            result = result.concat(child.getByIds(ids));
        }
        return result;
    };
    IdTitleNode.getByIds = function (items, ids) {
        var result = [];
        if (!items || items.length < 1 || !ids || ids.length < 1)
            return result;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            result = result.concat(item.getByIds(ids));
        }
        return result;
    };
    IdTitleNode.prototype.getFirstActiveNode = function () {
        if (this.active)
            return this;
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            var result = child.getFirstActiveNode();
            if (!result)
                continue;
            return result;
        }
        return null;
    };
    IdTitleNode.getFirstActiveNode = function (items) {
        if (!items || items.length < 1)
            return null;
        for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
            var item = items_3[_i];
            var result = item.getFirstActiveNode();
            if (!result)
                continue;
            return result;
        }
        return null;
    };
    IdTitleNode.prototype.getChildIds = function () {
        var result = this.children.map(function (i) { return i.id; });
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            result = result.concat(child.getChildIds());
        }
        return result;
    };
    IdTitleNode.getChildIds = function (items) {
        if (!items || items.length < 1)
            return [];
        var result = [];
        for (var _i = 0, items_4 = items; _i < items_4.length; _i++) {
            var item = items_4[_i];
            result = result.concat(item.getChildIds());
        }
        return result;
    };
    IdTitleNode.prototype.getActiveChildIds = function () {
        var result = this.children.filter(function (i) { return i.active; }).map(function (i) { return i.id; });
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            result = result.concat(child.getChildIds());
        }
        return result;
    };
    IdTitleNode.getActiveChildIds = function (items) {
        if (!items || items.length < 1)
            return [];
        var result = [];
        for (var _i = 0, items_5 = items; _i < items_5.length; _i++) {
            var item = items_5[_i];
            result = result.concat(item.getActiveChildIds());
        }
        return result;
    };
    IdTitleNode.prototype.containsAllChildrenIds = function (ids) {
        if (!ids || ids.length < this.children.length)
            return false;
        return this.children.filter(function (i) { return ids.indexOf(i.id) > -1; }).length === this.children.length;
    };
    IdTitleNode.prototype.containsSomeChildrenIds = function (ids) {
        if (!ids)
            return false;
        return this.children.filter(function (i) { return ids.indexOf(i.id) > -1; }).length > 0;
    };
    IdTitleNode.prototype.setHierarchialTitle = function (prefix) {
        this.title = (prefix ? prefix + " / " : "") + this.title;
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            child.setHierarchialTitle(this.title);
        }
    };
    IdTitleNode.sortUIdTitleNodes = function (items) {
        if (!items && items.length < 2)
            return items;
        var result = items.sort(function (a, b) { return (!a || !b) ? 0 : (Base.strCompare(a.title, b.title)); });
        for (var _i = 0, result_1 = result; _i < result_1.length; _i++) {
            var item = result_1[_i];
            item.children = IdTitleNode.sortUIdTitleNodes(item.children);
        }
        return result;
    };
    IdTitleNode.setHierarchialTitles = function (items) {
        for (var _i = 0, items_6 = items; _i < items_6.length; _i++) {
            var item = items_6[_i];
            item.setHierarchialTitle(null);
        }
    };
    IdTitleNode.prototype.removeIds = function (ids) {
        if (ids.indexOf(this.id) > -1) {
            return null;
        }
        var result = new IdTitleNode(this);
        result.children = [];
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            var newChild = child.removeIds(ids);
            if (!newChild)
                continue;
            result.children.push(newChild);
        }
        return result;
    };
    IdTitleNode.removeIds = function (items, ids) {
        var result = [];
        for (var _i = 0, items_7 = items; _i < items_7.length; _i++) {
            var item = items_7[_i];
            var newItem = item.removeIds(ids);
            if (!newItem)
                continue;
            result.push(newItem);
        }
        return result;
    };
    IdTitleNode.prototype.getAsList = function (list) {
        list.push(this);
        if (this.children.length < 1)
            return list;
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            child.getAsList(list);
        }
        return list;
    };
    IdTitleNode.getAsList = function (nodes) {
        if (!nodes || nodes.length < 1)
            return [];
        var result = [];
        for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
            var node = nodes_1[_i];
            node.getAsList(result);
        }
        return result;
    };
    IdTitleNode.equalIdsInArrays = function (a, b) {
        return Base.equalStrArrays(IdTitleNode.getAsList(a).map(function (i) { return i.id; }), IdTitleNode.getAsList(b).map(function (i) { return i.id; }));
    };
    IdTitleNode.equalIds = function (a, b) {
        return Base.equalStrArrays(IdTitleNode.getChildIds(a !== null && a !== void 0 ? a : []), IdTitleNode.getChildIds(b !== null && b !== void 0 ? b : []));
    };
    IdTitleNode.keepAvailableSelectedIds = function (items, selectedIds) {
        var result = selectedIds.slice(0);
        if (result.length > 0 && result[0] !== Base.emptyGuid) {
            var unitIds_1 = IdTitleNode.getChildIds(items);
            result = result.filter(function (i) { return unitIds_1.indexOf(i) > -1; });
        }
        return result;
    };
    return IdTitleNode;
}());
export { IdTitleNode };
